import { render, staticRenderFns } from "./AiConfig.vue?vue&type=template&id=3cf4438e&scoped=true"
import script from "./AiConfig.vue?vue&type=script&lang=js"
export * from "./AiConfig.vue?vue&type=script&lang=js"
import style0 from "./AiConfig.vue?vue&type=style&index=0&id=3cf4438e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf4438e",
  null
  
)

export default component.exports